import { Button, Card, Space, Table, Tag, Typography } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import { MockBanner } from '../../pages/components/MockBanner';
import { PageHeader } from '../../pages/components/PageHeader';

/** Org screen 11 — one employment record survives moves. */
export function OrgTransfersPage() {
  return (
    <div>
      <MockBanner when="the org-console staff sharing layer" needs="cross-institution membership queries" />
      <PageHeader
        title="Shared staff & transfers"
        subtitle="14 staff hold Memberships at more than one institution · one Person, many hats — payroll splits by percentage"
        actions={<Button type="primary" icon={<SwapOutlined />} disabled>Initiate transfer</Button>}
      />

      <Card size="small" title="Transfers pending" style={{ marginBottom: 12 }}>
        <Table
          size="small"
          pagination={false}
          rowKey="name"
          dataSource={PENDING}
          columns={[
            { title: 'Person', key: 'name', render: (_, r) => <div><div style={{ fontWeight: 600 }}>{r.name}</div><Typography.Text type="secondary" style={{ fontSize: 11.5 }}>{r.role}</Typography.Text></div> },
            { title: 'From', dataIndex: 'from', key: 'from' },
            { title: 'To', dataIndex: 'to', key: 'to' },
            { title: 'Effective', dataIndex: 'effective', key: 'effective', width: 120, render: (v: string) => <span style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}>{v}</span> },
            { title: 'Status', dataIndex: 'status', key: 'status', width: 200, render: (v: string, r) => <Tag color={r.tone}>{v}</Tag> },
            { key: 'act', width: 100, align: 'right', render: () => <Button size="small" disabled>Approve</Button> },
          ]}
        />
      </Card>

      <Card size="small" title="Shared staff" extra={<Typography.Text type="secondary" style={{ fontSize: 11.5 }}>People holding Memberships at more than one institution</Typography.Text>}>
        <Table
          size="small"
          pagination={false}
          rowKey="name"
          dataSource={SHARED}
          columns={[
            { title: 'Person', dataIndex: 'name', key: 'name', render: (v: string) => <span style={{ fontWeight: 600 }}>{v}</span> },
            { title: 'Memberships', key: 'memberships', render: (_, r) => <Space size={4} wrap>{r.memberships.map((m) => <Tag key={m}>{m}</Tag>)}</Space> },
            { title: 'Payroll split', dataIndex: 'split', key: 'split', width: 200, render: (v: string) => <span style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: 12 }}>{v}</span> },
            { title: 'Since', dataIndex: 'since', key: 'since', width: 100 },
          ]}
        />
        <Typography.Text type="secondary" style={{ display: 'block', fontSize: 11.5, marginTop: 8 }}>
          A driver employed by two institutions in one trust is one Person, one payroll record — split by percentage (P-05 for staff). Never two accounts (I-01).
        </Typography.Text>
      </Card>
    </div>
  );
}

const PENDING = [
  { name: 'A. Iyer', role: 'Coordinator · Science', from: 'Senior', to: 'College', effective: '01 Oct 2026', status: 'Awaiting principal approval', tone: 'warning' },
  { name: 'K. Kaur', role: 'Teacher · English', from: 'Primary', to: 'Senior', effective: '15 Oct 2026', status: 'Approved · onboarding scheduled', tone: 'success' },
];

const SHARED = [
  { name: 'V. Menon', memberships: ['Senior · Accounts', 'Primary · Accounts', 'College · Accounts'], split: '50 / 30 / 20', since: '2019' },
  { name: 'S. Bhonsle', memberships: ['Senior · Driver', 'Primary · Driver'], split: '60 / 40', since: '2022' },
  { name: 'P. Rao', memberships: ['Senior · Teacher', 'College · Guest lecturer'], split: '80 / 20', since: '2024' },
];
